
import { Discursive, DiscursiveGrades, DiscursiveHistory } from 'src/types';
import { defineComponent, ref, PropType, computed } from 'vue';
import format from 'date-fns/format';
export default defineComponent({
  name: 'DiscursiveFeedbackCard',
  components: {},
  props: {
    history: {
      type: Object as PropType<DiscursiveHistory>,
      require: true,
    },
    discursive: {
      type: Object as PropType<Discursive>,
      require: true,
    },
  },
  setup(props) {
    const subject = ref(props.history?.subject[0]);
    const lines = ref(props.history?.lineCount);
    const datetime = ref(
      format(new Date(props.history?._created as string), 'dd/MM/yyyy - HH:mm')
    );
    const linesFormatted = computed(() => {
      if (lines.value && lines.value < 10 && lines.value > 0) {
        return '0' + lines.value.toString();
      }
      return lines;
    });
    const totalScore = computed(() => {
      const discursive = props.discursive;
      if (discursive && discursive.criteria) {
        return discursive.criteria
          .reduce((acc, val) => acc + val.weight, 0)
          .toFixed(2);
      }
      return 0;
    });
    const userScore = computed(() => {
      const discursive = props.discursive;
      const history = props.history;
      if (discursive?.criteria.length && history?.grades.length) {
        const grades: DiscursiveGrades[] = history.grades;
        return grades
          .reduce((acc, val, index) => {
            if (discursive.criteria[index]) {
              return acc + val.grade * discursive.criteria[index].weight;
            }
            return 0;
          }, 0)
          .toFixed(2);
      }
      return 0;
    });

    return {
      subject,
      linesFormatted,
      datetime,
      totalScore,
      userScore,
    };
  },
});
